import { AggregatorClient, getProvidersExcluding, } from "@cetusprotocol/aggregator-sdk";
import { Transaction, } from "@mysten/sui/transactions";
import BN from "bn.js";
export class CetusSwap {
    network;
    client;
    cetusRouterDataV3;
    constructor(network) {
        this.network = network;
        this.client = new AggregatorClient({});
        this.cetusRouterDataV3 = null;
    }
    async getCetusSwapQuote(from, target, amount) {
        try {
            const providersExcept = getProvidersExcluding([
                "STEAMM_OMM_V2",
                "OBRIC",
                "METASTABLE",
                "HAEDALHMMV2",
                "HAEDALPMM",
                "BOLT",
            ]);
            const router = await this.client.findRouters({
                from,
                target,
                amount,
                byAmountIn: true, // `true` means fix input amount, `false` means fix output amount
                providers: providersExcept,
            });
            return router || undefined;
        }
        catch (error) {
            console.error("Error getting cetus swap quote", error);
            throw error;
        }
    }
    async cetusSwapTokensTxb(router, slippage, inputCoin, address, existingTx) {
        //Promise<{ tx: Transaction; coinOut?: TransactionObjectArgument }> {
        try {
            if (!router) {
                throw new Error("No routers found");
            }
            // Use existing transaction if provided, otherwise create new one
            const txb = existingTx || new Transaction();
            if (inputCoin && address) {
                // Use routerSwapWithMaxAmountIn when explicit coin control is needed
                const coinOut = await this.client.routerSwapWithMaxAmountIn({
                    router,
                    txb,
                    inputCoin: inputCoin,
                    slippage: slippage || 0.01,
                    maxAmountIn: new BN(router.amountIn.toString()),
                });
                return coinOut;
            }
            else {
                // Use fastRouterSwap for simple swaps
                await this.client.fastRouterSwap({
                    router,
                    txb,
                    slippage: slippage || 0.01,
                });
                return txb;
            }
        }
        catch (error) {
            console.error("Error swapping tokens in cetus swap", error);
            throw error;
        }
    }
    /**
     * Build swap transaction using routerSwap method (BuildRouterSwapParamsV3)
     * This method will completely consume the input coin amount and return target coin object.
     *
     * @param router - RouterData Object returned by findRouters method
     * @param txb - The programmable transaction builder
     * @param inputCoin - The input coin object to be swapped (will be completely consumed)
     * @param slippage - A value between 0 and 1, representing the maximum allowed price slippage
     * @returns TransactionObjectArgument - The target coin object that can be used in PTB
     */
    async routerSwapWithInputCoin(router, txb, inputCoin, slippage) {
        try {
            if (!router) {
                throw new Error("No router data provided");
            }
            const targetCoin = await this.client.routerSwap({
                router,
                txb,
                inputCoin,
                slippage,
            });
            return targetCoin;
        }
        catch (error) {
            console.error("Error in routerSwap:", error);
            throw error;
        }
    }
}
//# sourceMappingURL=cetusSwap.js.map